/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers'
import type { Provider } from '@ethersproject/providers'
import type { IFarmingHelperContract, IFarmingHelperContractInterface } from '../IFarmingHelperContract'

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_router',
        type: 'address',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [],
    name: 'router',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'mintScheduleNextTickSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'additionalSupplierNextTickSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'reciever',
        type: 'address',
      },
    ],
    name: 'currentSupplyRate',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const

export class IFarmingHelperContract__factory {
  static readonly abi = _abi
  static createInterface(): IFarmingHelperContractInterface {
    return new utils.Interface(_abi) as IFarmingHelperContractInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): IFarmingHelperContract {
    return new Contract(address, _abi, signerOrProvider) as IFarmingHelperContract
  }
}
